import { BarceloComponent } from "components-utils";

const AllArticle = {
  bwdArtCapt: BarceloComponent({
    selector: ".bwd-art-capt, .bwd-art-capt-dl-id",
    path: "bwd/article/bwd-article-caption/js/bwd-article-caption",
  }),

  bwdArticleShare: BarceloComponent({
    selector: ".bwd-article-share, .bwd-article-share-dl-id",
    path: "bwd/article/bwd-article-share/js/bwd-article-share",
  }),

  bwdArticleText: BarceloComponent({
    selector: ".bwd-article-text, .bwd-article-text-dl-id",
    path: "bwd/article/bwd-article-text/js/bwd-article-text",
  }),

  bwdArticlesList: BarceloComponent({
    selector: ".bwd-articles-list, .bwd-articles-list-dl-id",
    path: "bwd/article/bwd-articles-list/js/bwd-articles-list",
  }),

  bwdRelatedArticles: BarceloComponent({
    selector: ".bwd-related-articles, .bwd-related-articles-dl-id",
    path: "bwd/article/bwd-related-articles/js/bwd-related-articles",
  }),
};

export default AllArticle;
